export default __webpack_public_path__ + "static/media/logosN.4a965671.jpg";